export const filterConditionGteIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4 11.954l9.669-4.24L4 3.474 5.486 2l11.086 5.714-11.086 5.714zm0 4.572l11.429-5.383 1.143 1.143L5.486 18z"/></svg>`,
  name: 'filter-condition-gte',
};
